import { LoadableLazy } from '@confluence/loadable';

export const EnhanceOrientationTourNudgeLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EnhanceOrientationTourNudge" */ '../src/components/EnhanceOrientationTourNudge'
			)
		).EnhanceOrientationTourNudge,
});
